<p class="fs-3">Wybierz widok</p>
@if (linkedTransport) {
	<div class="w-100 alert alert-danger p-3 linked-transport-warning">
		{{ linkedTransportMessage }}
	</div>
}
@if (data.transport === null && data.elements.length === 1) {
	<div class="w-100 alert alert-danger p-3 term-warning">Ten termin nie ma utworzonego transportu</div>
} @else if (!data.same && data.elements.length > 1) {
	<div class="w-100 alert alert-danger p-3 term-warning">
		Zaznaczono więcej niż 1 termin, zostaniesz przekierowany do łączenia transportów
	</div>
}

@if (!data.exist && data.transportKind !== OfferTransportKind.PLANE) {
	<div>
		<p>Wczytaj szablon</p>
		<mat-form-field appearance="outline" class="w-100">
			<mat-label>Nazwa szablonu</mat-label>
			<input matInput [formControl]="selectedTemplate" [matAutocomplete]="autoTemplate" />
			<mat-autocomplete #autoTemplate [displayWith]="displayFn">
				@for (template of templates; track template.id) {
					<mat-option [value]="template">{{ template.name }} - {{ template.side }}</mat-option>
				}
			</mat-autocomplete>
		</mat-form-field>
		<button mat-raised-button class="button-load-template d-flex ms-auto" color="primary" (click)="loadTemplate()">
			Wczytaj
		</button>
	</div>
}

<mat-dialog-actions align="end" class="d-flex flex-row gap-2">
	<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button
		class="go-to-logic-button"
		mat-raised-button
		color="primary"
		mat-dialog-close
		(click)="goToTransport(TransportModule.MAP)"
	>
		Mapa
	</button>
	<ng-container *ngIf="data.same || selectedOnlyLinkedTransports">
		<button mat-raised-button color="primary" mat-dialog-close (click)="goToTransport(TransportModule.TIMETABLE)">
			Rozkład
		</button>

		<button mat-raised-button color="primary" mat-dialog-close (click)="goToTransport(TransportModule.LIST)">
			Listy
		</button>

		<button mat-raised-button color="primary" mat-dialog-close (click)="goToTransport(TransportModule.COACH_LIST)">
			Listy autokarowe
		</button>
	</ng-container>
</mat-dialog-actions>
